const prefix = 'subCommunities';

export const SET_SUB_COMMUNITIES = `${prefix}/SET_SUB_COMMUNITIES`;
export const SET_SUB_COMMUNITIES_TO_JOIN = `${prefix}/SET_SUB_COMMUNITIES_TO_JOIN`;
export const REMOVE_SUB_COMMUNITY = `${prefix}/REMOVE_SUB_COMMUNITY`;
